export default __webpack_public_path__ + "static/media/ill-kyc-verification.b67a9ff8.svg";